module.exports = __webpack_public_path__ + "static/img/pic-active-pic2.181db69.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic-active-pic2.png
// module id = 161
// module chunks = 0